import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  computed,
  inject,
  input,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgTemplateOutlet } from '@angular/common';
import { Ag1BadgeSolidComponent } from '../ag1-badge-solid/ag1-badge-solid.component';

@Component({
  selector: 'ag1-title',
  templateUrl: './ag1-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, Ag1BadgeSolidComponent],
})
export class Ag1TitleComponent implements OnInit, OnDestroy {
  private titleService = inject(Title);

  readonly label = input('Title');

  readonly state = input<'new' | 'beta' | 'alpha' | undefined>(undefined);

  readonly showStateBadge = computed(() => !!this.state());

  agrigateOne: string = 'AgrigateOne';

  constructor() {}

  ngOnInit(): void {
    const label = this.label();
    if (label === 'Title' || !label) {
      this.titleService.setTitle(this.agrigateOne);
      return;
    }

    this.titleService.setTitle(`${this.agrigateOne} | ${label}`);
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(this.agrigateOne);
  }
}
